import React from 'react';
import { Spinner } from 'react-bootstrap';
 
const LoadingSpinner = (props) => (
    <Spinner 
        animation="border"
        className={props.className}
        size={props.size}
        style={props.inButton ? {marginLeft: "0.5rem"} : null}
        variant={props.variant}
         />
);

export default LoadingSpinner;